export enum PaymentStates {
  Pending,
  Success,
  Refresh,
  Failure,
}
